var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.5,
    height: 104.757,
    viewBox: "0 0 164.5 104.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1126.309,1229.214l-25.795,74.9c-14.711-5.206-34.52-8.4-56.321-8.4-21.916,0-41.834,3.209-56.546,8.472l-25.838-74.971,27.61,19.415-5.918,16.29.489.393a19.059,19.059,0,0,0,28.628-5.124l-13.05-12.591,14.32-36.683,24.162,28.182-10.622,18.732,2.974,3.058a19.073,19.073,0,0,0,27.331,0l2.971-3.058-10.635-18.732,24.161-28.182,14.323,36.683-13.052,12.591a19.072,19.072,0,0,0,28.628,5.124l.487-.393-5.916-16.29Z",
    transform: "translate(-961.809 -1210.914)",
    fill: "#e4a231"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1073.9,1225.218l-2.692,7.454c-14.184-4.411-32.371-7.049-52.22-7.049-20.1,0-38.5,2.707-52.776,7.229l-2.457-7.509c14.587-5,33.975-8.038,55.233-8.038,21.119,0,40.367,2.986,54.912,7.913",
    transform: "translate(-936.619 -1128.095)",
    fill: "#e4a231"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.349a297aecae9078e80cb2e19819cdd7.svg";
export { ForwardRef as ReactComponent };